// 
// user.js
// Use this to write your custom JS
//

const Cookies = require('js-cookie');

window.addEventListener('DOMContentLoaded', (event) => {
  let forwardParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'device', 'matchtype', 'creative', 'referrer'];

  let locationParams = new URLSearchParams(window.location.search);

  //grab and store on 1st page load
  for(var key of locationParams.keys()) {
    if (forwardParams.includes(key)) {
        //set localstorage
        window.localStorage.setItem(key, locationParams.get(key));
        Cookies.set(key, locationParams.get(key), {expires:365, domain:'.cardscan.ai'});
    }
  }

  if (Cookies.get('referrer')) {
      //don't overwrite referrer
  } else if (document.referrer.length > 0 && !(document.referrer.includes('www.cardscan.ai') || document.referrer.includes('localhost'))) {
    //only set referrer if not localhost or www.cardscan.ai or undefined
    Cookies.set('referrer', document.referrer, {expires:365, domain:'.cardscan.ai'});
  }

  function handleCTA(e) {
    e.preventDefault();
    var payload = e.currentTarget.dataset.pageloc.split(",");
    payload = payload.map((i) => i.split('='));
    payload = Object.assign({}, ...payload.map((x) => ({[x[0]]: x[1]})));

    forwardParams.forEach(p => {
      //if param set grab and add to form.
      if (locationParams.get(p)) {
        payload[p] = locationParams.get(p);
      } else if(window.localStorage.getItem(p)) {
        payload[p] = window.localStorage.getItem(p);
      } else if (Cookies.get(p) != null) {
        payload[p] = Cookies.get(p);
      }
    });

    var elements = e.currentTarget.getElementsByTagName('input')
    
    for (let p of elements) {
      if (p.value) { 
        payload['email'] = p.value 
      }
    }

    const params = new URLSearchParams(payload);
    const url = `https://dashboard.cardscan.ai/onboarding?${params.toString()}`;
    // const url = `http://localhost:3000/onboarding?${params.toString()}`;

    window.location.href = url
    return false
  }

  var forms = document.getElementsByClassName('form-cta');
  for (let form of forms) {
      form.addEventListener("submit", handleCTA);
  }

});

 window.addEventListener('DOMContentLoaded', (event) => {

  if (window.lintrk === undefined) {
    return
  }

  //add LinkedIn goal tracking.
  var forms = document.getElementsByClassName('form-cta');
  for (let form of forms) {
    form.addEventListener("submit", () => {
      window.lintrk('track', { conversion_id: 4684932 });
    })  
  }
});

window.addEventListener('DOMContentLoaded', (event) => {

  const contactForm = document.getElementsByName('contact-form');

  for (let form of contactForm) {
    form.addEventListener("submit", sendContactForm);
  }

  function sendContactForm(event) {
    event.preventDefault() 
    var data = new FormData(event.target);

    button = document.getElementById('contactSubmit');
    button.disabled = true;
    button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span> Sending...';
    
    fetch('https://dash.cardscan.ai/v1/contact', {
      method: 'POST',
      body: JSON.stringify(Object.fromEntries(data)),
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(response => {
      if (!response.ok) {
        error = response.json()
        throw new Error(error['errorMessage']);
      }
      button.classList.replace('btn-primary', 'btn-success')
      button.innerHTML = '<i class="fe fe-check-circle"></i> Sent';    
    }).catch(error => {
      console.error('Fetch error:', error);
      button.disabled = false;
      button.innerHTML = '<i class="fe fe-alert-triangle"></i> An error occurred - please try again';
    });
    
    if (window.lintrk != undefined) {
      window.lintrk('track', { conversion_id: 4684940 });
    }

    return false
  }

});